const accessAndPricingFaqItems = [
  {
    question: 'Is All-Voiced free?',
    answer:
      'Many current activities are free to access, while other entries may require payment, eligibility, institutional access, or another condition. Institutional, research, and annotation implementations are scoped separately.',
  },
  {
    question: 'Are all catalog entries free?',
    answer:
      'No. The catalog may contain free, paid, restricted, institutional, or otherwise conditioned entries. The current access model is shown in each entry.',
  },
  {
    question: 'Do I need a subscription?',
    answer:
      'Not necessarily. All-Voiced does not currently use one universal subscription as the access model for the entire ecosystem. Access depends on the catalog entry or agreed implementation.',
  },
  {
    question: 'Where can I see the price or access conditions for a catalog entry?',
    answer:
      'The app catalog is the operational source of truth for catalog-entry access. Each entry should show its current access conditions, intended audience, and available launch pathway when applicable.',
  },
  {
    question: 'Can I use free activities without contacting All-Voiced?',
    answer:
      'Yes, when the catalog entry allows direct launch or self-service access. Some entries may still require registration, eligibility, institutional access, or another condition even when no payment is required.',
  },
  {
    question: 'Can an educator use free activities with students?',
    answer:
      'Yes, where the entry’s intended use and access conditions allow it. Configured cohorts, assessment, analytics, reporting, or institutional support may require an Institutional Program.',
  },
  {
    question: 'When is an Institutional Program needed?',
    answer:
      'An Institutional Program becomes relevant when an institution needs configured implementation, cohort workflows, assessment, analytics, reporting, support, co-development, or institution-specific access.',
  },
  {
    question: 'Are Institutional Programs sold as fixed packages?',
    answer:
      'No. Institutional Programs are configured according to the institution’s goals, participants, required capabilities, implementation context, support needs, and access model.',
  },
  {
    question: 'How is research-project pricing determined?',
    answer:
      'Pricing depends on the perceptual protocol, samples, evaluators, tasks, phases, monitoring, outputs, governance, support, and any custom implementation required for the agreed study workflow.',
  },
  {
    question: 'How is Perceptual Data Annotation pricing determined?',
    answer:
      'Pricing depends on dataset size, perceptual constructs, evaluator workflow, number of judgments, repetitions, quality requirements, outputs, governance, and coordination.',
  },
  {
    question: 'Is pricing based only on the number of users, evaluators, or samples?',
    answer:
      'Not by default. Counts matter, but methodological complexity, evaluator requirements, governance, outputs, support, and custom implementation may substantially affect scope.',
  },
  {
    question: 'Do custom projects include dashboards, reports, analytics, or exports?',
    answer:
      'Dashboards, reports, analytics, exports, and other outputs are included only where supported and explicitly defined in the agreed scope.',
  },
  {
    question: 'Can we begin with a pilot or smaller scope?',
    answer:
      'Yes. A pilot, limited dataset, single activity, or focused course implementation may be an appropriate way to test and refine the workflow before expanding.',
  },
  {
    question: 'Are evaluator recruitment or calibration included?',
    answer:
      'Not by default. Evaluator recruitment, preparation, familiarization, training, calibration, or panel coordination depend on the project design and agreed responsibilities.',
  },
  {
    question: 'Are discounts available for universities, research projects, or collaborations?',
    answer:
      'Pricing and collaboration models may vary for universities, research collaborations, pilots, public-interest projects, or strategic partnerships. Any adjustment is considered case by case and should not be assumed automatically.',
  },
  {
    question: 'How do we request a proposal?',
    answer:
      'Contact All-Voiced with the relevant context, scope, users or evaluators, samples, timeline, required outputs, and governance constraints. The proposal can then be scoped around the concrete implementation needs.',
  },
];

export default function AccessAndPricingFAQ() {
  return (
    <section
      className="service-landing-section service-landing-faq"
      aria-labelledby="access-and-pricing-faq-title"
    >
      <span className="services-label">
        FAQ
      </span>

      <h2 id="access-and-pricing-faq-title">
        Access & Pricing FAQ
      </h2>

      <p>
        Common questions about free and paid catalog entries, institutional
        access, custom project pricing, and how to choose the appropriate
        All-Voiced pathway.
      </p>

      <div className="service-landing-faq-list">
        {accessAndPricingFaqItems.map((item) => (
          <details className="service-landing-faq-item" key={item.question}>
            <summary>
              <span>{item.question}</span>
            </summary>

            <p>{item.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
